import {makeAutoObservable} from "mobx";
import {displayErrorDialogPrompt} from "../common/util/errror/log.util";
import {getDayPath, getDefaultContentUrl} from "./ContentStore";
import {langTypes} from "../common/enums/ExcelEnum";

const logPrefix  = "[EvenStepFourStore]"
export default class EvenStepFourStore {

    constructor(props) {
        this.contentRepository = props.contentRepository;
        this.contentStore = props.contentStore;
        this.dialogStore = props.dialogStore;
        this.commonStore = props.commonStore;

        this.contentTapIndex = 0;
        this.contentList = [];
        this.selectedContent = [];
        this.audio = null;
        this.readyToSaveStep = false;
        this.stepValue = 0;
        this.dayValue = 0;

        makeAutoObservable(this);
    }

    initEvenStepFourContent = () => {
        this.contentList = [];
        this.selectedContent = [];
        this.contentTapIndex = 0;
        this.audio = null;
    }

    setContentTapIndex = (index) => {
        this.contentTapIndex = index;
        this.setSelectedContent();
    };

    openErrorDialog = (info) => {
        if (this?.dialogStore) {
            this.dialogStore.openErrorDialog(info)
        }
    }

    setStepValue = (step) => {
        this.stepValue = step;
    }

    setDayValue = (day) => {
        this.dayValue = day;
    }

    setSelectedContent = () => {
        this.selectedContent = this.getSelectedContent(this.getSelectedLangCode());
    }

    setVoiceTypeByIndex = (voiceType, index) => {
        const contents = Array.from(this.contentList[index].contents);
        contents.forEach(content => {
            content.voiceType = voiceType;
            content.audioExist = false;
            content.descriptionAudioExist = false;
        });
        this.contentList[index].contents = contents;
        this.contentStore.setReadyToSaveStep(this.isEvenStepFourCompleted());
        this.readyToSaveStep = this.isEvenStepFourCompleted();
    }

    setWritingContentText = (text, languageCode, index, isWord) => {
        const contents = Array.from(this.contentList[index].contents);
        contents.forEach(c => {
            if (c.languageCode === languageCode) {
                if (isWord) {
                    c.word = text;
                    c.audioExist = false;
                } else {
                    c.description = text;
                    c.descriptionAudioExist = false;
                }
            }
        });
        this.contentList[index].contents = contents;
        this.contentStore.setReadyToSaveStep(this.isEvenStepFourCompleted());
        this.readyToSaveStep = this.isEvenStepFourCompleted();
    }

    setImgFileByIndex = (file, index, fileName) => {
        this.contentList[index].image = file.split(";base64,")[1];
        console.log(fileName);
        if(!fileName) {
            this.contentList[index].generateType = 'AI';
            this.contentList[index].originalFileName = `writing_${index+1}.jpeg`;
            this.contentList[index].originalFileExtension = 'jpeg';
        } else {
            this.contentList[index].generateType = 'Upload';
            this.contentList[index].originalFileName = fileName;
            this.contentList[index].originalFileExtension = file.split(";base64,")[0].split("/")[1];
        }
        this.contentStore.setReadyToSaveStep(this.isEvenStepFourCompleted());
        this.readyToSaveStep = this.isEvenStepFourCompleted();
    }

    setWritingContentAudio = (audio, languageCode, index, isWord) => {
        const contents = Array.from(this.contentList[index].contents);
        contents.forEach(c => {
            if (c.languageCode === languageCode) {
                if (isWord) {
                    c.audio = audio.split(',')[1];
                    c.audioExist = true;
                } else {
                    c.descriptionAudio = audio.split(',')[1];
                    c.descriptionAudioExist = true;
                }
            }
        });
        this.contentList[index].contents = contents;
        this.contentStore.setReadyToSaveStep(this.isEvenStepFourCompleted());
        this.readyToSaveStep = this.isEvenStepFourCompleted();
    }

    getSelectedLangCode = () => {
        return langTypes[this.contentTapIndex];
    }

    getSelectedContent = (langeCode) => {
        return this.contentList.filter(content => content.languageCode === langeCode);
    }

    isEvenStepFourCompleted = () => {
        let hasEmptyValues = false;

        for (const sequenceContent of this.contentList) {
            if (sequenceContent.contents.some(content => content.word === '' || content.description === '')) {
                hasEmptyValues = true;
                break;
            }
        }

        return !hasEmptyValues;
    }

    playAudio = (audio, id) => {
        if (this.audio && !this.audio.paused && this.audio.id === id) {
            this.stopAudio();
        } else {
            if (this.audio) {
                this.stopAudio();
            }
            const decodeAudio = atob(audio);
            const blob = new Blob([new Uint8Array(decodeAudio.length).map((_, i) => decodeAudio.charCodeAt(i))], {type: 'audio/mp3'});
            this.audio = new Audio();
            this.audio.id = id;
            this.audio.src = URL.createObjectURL(blob);
            this.audio.play();
        }
    }

    stopAudio = () => {
        if (this.audio) {
            this.audio.pause();
            this.audio = null;
        }
    }

    convertRequestContents = () => {
        return this.contentList.map((c) => ({
            contentId: c.contentId,
            image: c.image,
            originalFileName: c.originalFileName || "",
            originalFileExtension: c.originalFileExtension || "",
            generateType: c.generateType,
            contents: c.contents
        }));
    }


    * getEvenStepFourContent(step, day) {
        this.commonStore.setLoadingState();
        try {
            console.log(logPrefix, 'Start getEvenStepFourContent.');
            const url = `${getDayPath(day)}/${getDefaultContentUrl(step, day)}/4`;
            const response = yield this.contentRepository.getContent(url);

            if (response.data !== null) {
                this.contentList = response.data;
            }

            this.contentStore.setReadyToMoveExit(this.isEvenStepFourCompleted());
            this.contentStore.setReadyToSaveStep(false);
            this.readyToSaveStep = false;
            console.log(logPrefix, 'Finished getEvenStepFourContent.');
        } catch (e) {
            console.log(logPrefix, 'Failed getEvenStepFourContent.');
            this.openErrorDialog({
                titleText: '컨텐츠 불러오기 오류',
                text: displayErrorDialogPrompt(e, '컨텐츠를 불러오는 도중 에러가 발생했습니다.')
            });
        } finally {
            this.commonStore.initLoadingState();
        }
    }

    * modifyEvenStepFourContent(step, day) {
        this.commonStore.setLoadingState('데이터를 저장하는 중입니다.');
        try {
            console.log(logPrefix, 'Start modifyEvenStepFourContent.');
            const url = `${getDayPath(day)}/${getDefaultContentUrl(step, day)}/4`;
            const requestContents = this.convertRequestContents();
            console.log(logPrefix, 'modifyEvenStepFourContent requestContents :', requestContents);
            yield this.contentRepository.putContent(url, requestContents);
            console.log(logPrefix, 'Finished modifyEvenStepFourContent.');
            this.requestTranslations = [];
            // this.openErrorDialog({
            //     titleText: '저장 성공',
            //     text: displayErrorDialogPrompt('',  '컨텐츠를 정상적으로 저장하였습니다.')
            // });
            this.getEvenStepFourContent(step, day);
        } catch (e) {
            this.commonStore.initLoadingState();
            console.log(logPrefix, 'Failed modifyEvenStepFourContent.');
            this.openErrorDialog({
                titleText: 'Writing 컨텐츠 수정 오류',
                text: displayErrorDialogPrompt(e, 'Writing 컨텐츠 수정 작업중 에러가 발생했습니다.')
            });
        }
    }

}

